
import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action, State } from "vuex-class";
import { get, clone, cloneDeep } from "lodash";
import { GuardTour, GuardTourStep } from "@/store/guard-tours/types";
import ActionPlanLinker from "@/components/guard-tours/ActionPlanLinker.vue";

const GuardTours = namespace("GuardTours");
const MapLayers = namespace("mapLayers");

@Component({
	components: {
        "action-plan-linker": ActionPlanLinker,
	}
})
export default class TourStepItem extends Vue {
    @MapLayers.Getter("getMapItemIcons") public mapIcons!: any[];

    @GuardTours.State currentGuardTour: GuardTour;
    @GuardTours.Mutation setScriptIdForGuardTourStep: ({stepIndex, scriptId}) => void;
    @GuardTours.Mutation setTitleForWaypointTourStep: ({stepIndex, title}) => void;
    @GuardTours.Mutation removeGuardTourStep: (guardTourStep: GuardTourStep) => void;

    @Prop()
    public tourStep: GuardTourStep;    

    @Emit("remove-waypoint")
    private removeWaypoint(tourStep: GuardTourStep) {}

    @Emit("save-tour")
    private saveTour() {}

    public editableWaypointName: string = "";
    public showRenamingModal: boolean = false;

    private getMapItemIcon(mapItemTypeId: number): string {
        return this.mapIcons[mapItemTypeId];
    }

    public renameWaypointClick(tourStep: GuardTourStep): void {
        this.showRenamingModal = true;
        this.editableWaypointName = tourStep.mapLayerItemTitle;
    }

    public async saveWaypointName(): Promise<void> {
        const stepIndex = this.getTourStepIndex(this.tourStep.guardTourStepId);
        this.setTitleForWaypointTourStep({stepIndex: stepIndex, title: this.editableWaypointName});
        
        this.editableWaypointName = "";
        this.showRenamingModal = false;
    }

    public removeTourStep(tourStep: GuardTourStep): void {
        this.removeGuardTourStep(tourStep);

        if (tourStep.mapLayerItemTypeId == 101) {
            this.removeWaypoint(tourStep);
        }
    }

    private linkPlanToStep(guardTourStepId: number, scriptId: number) {
        const stepIndex = this.getTourStepIndex(guardTourStepId);

        // update the GuardTour object, changes are applied on saves
        this.setScriptIdForGuardTourStep({stepIndex: stepIndex, scriptId: scriptId});
        this.saveTour();
    }

    private getTourStepIndex(guardTourStepId: number){
        // find the index of the step we are looking to update
        return this.currentGuardTour.guardTourSteps.findIndex(
            (f: GuardTourStep) => f.guardTourStepId == guardTourStepId
        );
    }
}
